
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.715 12.367L12.908 23.61h2.888l1.806-11.243h-2.887zm8.711 4.58c-1.01-.498-1.628-.835-1.628-1.344.013-.464.523-.939 1.664-.939a5.025 5.025 0 012.151.417l.262.117.393-2.353a7.288 7.288 0 00-2.592-.463c-2.852 0-4.86 1.483-4.873 3.603-.023 1.565 1.438 2.434 2.532 2.954 1.117.535 1.497.881 1.497 1.356-.012.73-.903 1.065-1.735 1.065-1.152 0-1.77-.173-2.71-.579l-.38-.173-.404 2.444c.678.302 1.926.567 3.221.581 3.03 0 5.003-1.46 5.028-3.72.01-1.24-.761-2.19-2.426-2.966zm10.245-4.545h-2.234c-.689 0-1.212.198-1.51.905l-4.29 10.303h3.031l.835-2.23h3.39l.434 2.24H36l-2.329-11.218zm-3.327 6.726c.058.006 1.163-3.641 1.163-3.641l.88 3.641h-2.043zm-19.849-6.76l-2.83 7.638-.307-1.506c-.524-1.739-2.164-3.627-3.994-4.566l2.59 9.665H9.01l4.54-11.23h-3.055v-.002z","fill":"#2394BC"}}),_c('path',{attrs:{"d":"M6.406 13.817c-.22-.857-.924-1.435-1.879-1.448H.047L0 12.577c3.495.862 6.43 3.514 7.381 6.008l-.975-4.768z","fill":"#EFC75E"}})])
          )
        }
      }
    